import React, { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Text } from '@asigna/kit';
import { useActivateSafeFromUrlParam } from 'hooks';
import useSafe from 'hooks/use-safe';
import { useSendStxDialog } from 'store';
import { Tab } from 'ui-kit';

import { AssetTabKey, useAssetsPage } from './util/useAssetsPage';
import { AssetsTab, NFTsTab, Stx20Tab } from './components';

export const AssetsPage: React.FC = () => {
  useActivateSafeFromUrlParam();
  const { search } = useLocation();
  const history = useHistory();
  const { safe, assetList, stxBalance } = useSafe();
  const { setSendStxDialogOpen, setSelectedTokenIndex } = useSendStxDialog();

  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  const { tabs, selectedTabKey, setSelectedTabKey, loading } = useAssetsPage();

  const handleTabClick = (tabKey: AssetTabKey) => {
    setSelectedTabKey(tabKey);
    searchParams.set('selectedTabKey', tabKey);
    history.replace({ search: searchParams.toString() });
  };

  return (
    <div className="flex w-full pr-0 sm:pr-24 pl-0 sm:pl-0 h-screen py-16">
      <div className="flex flex-col sm:rounded-[16px] sm:bg-black-1 w-full relative p-16 sm:p-32 overflow-y-scroll">
        <Text message="Assets" color="white" size="r24" className="mb-20" />
        <div className="flex gap-8 pb-4 sm:pb-0 overflow-x-auto min-h-40 mx-[-16px] sm:mx-0 px-16 sm:px-0">
          {(Object.keys(tabs) as AssetTabKey[]).map((tabKey) => {
            return (
              <Tab
                id={tabKey}
                key={tabKey}
                isActive={tabKey === selectedTabKey}
                onClick={handleTabClick}
              >
                <span>{tabs[tabKey]}</span>
              </Tab>
            );
          })}
        </div>
        <div className="w-full mt-20 mb-32">
          <div>
            {selectedTabKey === 'tokens' && (
              <AssetsTab
                assetList={assetList}
                setClickIndex={setSelectedTokenIndex}
                showInstantSendDialog={() => setSendStxDialogOpen(true)}
                loading={loading}
                stxBalance={stxBalance}
              />
            )}
            {selectedTabKey === 'nfts' && <NFTsTab />}
            {selectedTabKey === 'stx20' && <Stx20Tab currentSafe={safe.address || ''} />}
          </div>
        </div>
      </div>
    </div>
  );
};
